import script from "./Confirmations.vue?vue&type=script&lang=ts&setup=true"
export * from "./Confirmations.vue?vue&type=script&lang=ts&setup=true"

import "./Confirmations.vue?vue&type=style&index=0&id=d2a2712c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d2a2712c"]])

export default __exports__